export default function ErrorPage(props: {
  children: React.ReactNode
}) {
  return (
    <div className="container d-flex justify-content-center align-items-center">
      <div className="container-center" style={{ paddingTop: '30vh' }}>
        <div className="text-center">
          <h1>{props.children}</h1>
          <p>Please contact OMS operations team.</p>
        </div>
      </div>
    </div>
  );
}
